module.exports = __webpack_public_path__ + "img/arrow-down-1.6aff2b9d.svg";